module.exports = __webpack_public_path__ + "img/EMT-CRC_10X_TGSP.18e213a4.png";